import type { Icon } from '@phosphor-icons/react'
import {
  InfinityIcon,
  AirplaneIcon,
  AlarmIcon,
  AmbulanceIcon,
  ArrowCircleDownIcon,
  ArrowCircleRightIcon,
  ArrowCircleUpIcon,
  ArrowClockwiseIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowSquareOutIcon,
  ArrowUpIcon,
  ArrowUpRightIcon,
  ArrowsClockwiseIcon,
  ArrowsOutIcon,
  ArrowsOutSimpleIcon,
  BabyCarriageIcon,
  BabyIcon,
  BandaidsIcon,
  BankIcon,
  BedIcon,
  BicycleIcon,
  BinocularsIcon,
  BoneIcon,
  BookOpenIcon,
  BrainIcon,
  BriefcaseIcon,
  BrowserIcon,
  BuildingsIcon,
  CalculatorIcon,
  CalendarBlankIcon,
  CalendarCheckIcon,
  CalendarDotsIcon,
  CalendarIcon,
  CalendarSlashIcon,
  CalendarXIcon,
  CallBellIcon,
  CameraIcon,
  CarIcon,
  CarProfileIcon,
  CarSimpleIcon,
  CaretDoubleRightIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretUpIcon,
  ChartLineIcon,
  ChartLineUpIcon,
  ChartPieSliceIcon,
  ChatCircleDotsIcon,
  CheckCircleIcon,
  CheckIcon,
  CheersIcon,
  ClipboardTextIcon,
  ClockCountdownIcon,
  ClockIcon,
  CloudArrowDownIcon,
  CloudLightningIcon,
  CoinVerticalIcon,
  CoinsIcon,
  ConfettiIcon,
  CouchIcon,
  CpuIcon,
  CreditCardIcon,
  DeviceMobileIcon,
  DeviceMobileSpeakerIcon,
  DogIcon,
  DotOutlineIcon,
  DotsSixVerticalIcon,
  DownloadSimpleIcon,
  DroneIcon,
  DropIcon,
  EnvelopeIcon,
  ExclamationMarkIcon,
  ExportIcon,
  EyeIcon,
  FadersHorizontalIcon,
  FilePdfIcon,
  FileTextIcon,
  FilesIcon,
  FireIcon,
  FirstAidIcon,
  FirstAidKitIcon,
  FlagCheckeredIcon,
  FlameIcon,
  GavelIcon,
  GearSixIcon,
  GenderFemaleIcon,
  GenderMaleIcon,
  GiftIcon,
  GlobeHemisphereWestIcon,
  GlobeIcon,
  HandCoinsIcon,
  HandHeartIcon,
  HandsClappingIcon,
  HeadphonesIcon,
  HeartHalfIcon,
  HeartIcon,
  HeartStraightIcon,
  HeartbeatIcon,
  HospitalIcon,
  HouseIcon,
  HouseLineIcon,
  IdentificationCardIcon,
  ImageBrokenIcon,
  ImagesIcon,
  InfoIcon,
  IslandIcon,
  KeyIcon,
  LaptopIcon,
  LeafIcon,
  LetterCirclePIcon,
  LifebuoyIcon,
  LightbulbIcon,
  LightningIcon,
  ListChecksIcon,
  ListDashesIcon,
  ListMagnifyingGlassIcon,
  LockIcon,
  LockKeyIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  MapPinLineIcon,
  MedalIcon,
  MinusCircleIcon,
  MoneyIcon,
  MoneyWavyIcon,
  NewspaperIcon,
  NumberCircleFiveIcon,
  NumpadIcon,
  OrangeIcon,
  PackageIcon,
  PaintBrushHouseholdIcon,
  PaperPlaneTiltIcon,
  PaperclipIcon,
  ParachuteIcon,
  PawPrintIcon,
  PencilCircleIcon,
  PencilIcon,
  PencilSimpleIcon,
  PersonSimpleBikeIcon,
  PersonSimpleRunIcon,
  PhoneCallIcon,
  PhoneIcon,
  PicnicTableIcon,
  PiggyBankIcon,
  PillIcon,
  PlantIcon,
  PlayCircleIcon,
  PlusCircleIcon,
  PlusIcon,
  ProhibitIcon,
  QuestionIcon,
  QuestionMarkIcon,
  ReceiptIcon,
  ScalesIcon,
  ScrollIcon,
  SealCheckIcon,
  SealPercentIcon,
  SealQuestionIcon,
  ShieldCheckIcon,
  ShieldCheckeredIcon,
  ShieldIcon,
  ShieldWarningIcon,
  ShoppingCartIcon,
  SignatureIcon,
  SignpostIcon,
  SketchLogoIcon,
  SlidersHorizontalIcon,
  SmileyAngryIcon,
  SmileyIcon,
  SmileyMehIcon,
  SmileyNervousIcon,
  SmileySadIcon,
  SmileyWinkIcon,
  SparkleIcon,
  SpinnerGapIcon,
  StampIcon,
  StarIcon,
  SteeringWheelIcon,
  StethoscopeIcon,
  SuitcaseSimpleIcon,
  SunIcon,
  SwapIcon,
  SwimmingPoolIcon,
  SyringeIcon,
  TShirtIcon,
  TagIcon,
  TargetIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TimerIcon,
  ToggleRightIcon,
  ToothIcon,
  TrainRegionalIcon,
  TrashIcon,
  TreeIcon,
  TrendDownIcon,
  TrendUpIcon,
  UploadSimpleIcon,
  UserCircleDashedIcon,
  UserCircleIcon,
  UserFocusIcon,
  UserIcon,
  UserRectangleIcon,
  UserSoundIcon,
  UserSquareIcon,
  UsersFourIcon,
  UsersIcon,
  UsersThreeIcon,
  VideoCameraIcon,
  VirusIcon,
  WalletIcon,
  WarningIcon,
  WarningOctagonIcon,
  WrenchIcon,
  XCircleIcon,
  XIcon,
} from '@phosphor-icons/react'

import type { PhosphorIconName } from './iconNames'

/** Web (@phosphor-icons/react) Phosphor icon registry. Keyed by {@link PhosphorIconName}. */
export const iconRegistry: Record<PhosphorIconName, Icon> = {
  Airplane: AirplaneIcon,
  Alarm: AlarmIcon,
  Ambulance: AmbulanceIcon,
  ArrowCircleDown: ArrowCircleDownIcon,
  ArrowCircleRight: ArrowCircleRightIcon,
  ArrowCircleUp: ArrowCircleUpIcon,
  ArrowClockwise: ArrowClockwiseIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowSquareOut: ArrowSquareOutIcon,
  ArrowUp: ArrowUpIcon,
  ArrowUpRight: ArrowUpRightIcon,
  ArrowsClockwise: ArrowsClockwiseIcon,
  ArrowsOut: ArrowsOutIcon,
  ArrowsOutSimple: ArrowsOutSimpleIcon,
  Baby: BabyIcon,
  BabyCarriage: BabyCarriageIcon,
  Bandaids: BandaidsIcon,
  Bank: BankIcon,
  Bed: BedIcon,
  Bicycle: BicycleIcon,
  Binoculars: BinocularsIcon,
  Bone: BoneIcon,
  BookOpen: BookOpenIcon,
  Brain: BrainIcon,
  Briefcase: BriefcaseIcon,
  Browser: BrowserIcon,
  Buildings: BuildingsIcon,
  Calculator: CalculatorIcon,
  Calendar: CalendarIcon,
  CalendarBlank: CalendarBlankIcon,
  CalendarCheck: CalendarCheckIcon,
  CalendarDots: CalendarDotsIcon,
  CalendarSlash: CalendarSlashIcon,
  CalendarX: CalendarXIcon,
  CallBell: CallBellIcon,
  Camera: CameraIcon,
  Car: CarIcon,
  CarProfile: CarProfileIcon,
  CarSimple: CarSimpleIcon,
  CaretDoubleRight: CaretDoubleRightIcon,
  CaretDown: CaretDownIcon,
  CaretLeft: CaretLeftIcon,
  CaretRight: CaretRightIcon,
  CaretUp: CaretUpIcon,
  ChartLine: ChartLineIcon,
  ChartLineUp: ChartLineUpIcon,
  ChartPieSlice: ChartPieSliceIcon,
  ChatCircleDots: ChatCircleDotsIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  Cheers: CheersIcon,
  ClipboardText: ClipboardTextIcon,
  Clock: ClockIcon,
  ClockCountdown: ClockCountdownIcon,
  CloudArrowDown: CloudArrowDownIcon,
  CloudLightning: CloudLightningIcon,
  CoinVertical: CoinVerticalIcon,
  Coins: CoinsIcon,
  Confetti: ConfettiIcon,
  Couch: CouchIcon,
  Cpu: CpuIcon,
  CreditCard: CreditCardIcon,
  DeviceMobile: DeviceMobileIcon,
  DeviceMobileSpeaker: DeviceMobileSpeakerIcon,
  Dog: DogIcon,
  DotOutline: DotOutlineIcon,
  DotsSixVertical: DotsSixVerticalIcon,
  DownloadSimple: DownloadSimpleIcon,
  Drone: DroneIcon,
  Drop: DropIcon,
  Envelope: EnvelopeIcon,
  ExclamationMark: ExclamationMarkIcon,
  Export: ExportIcon,
  Eye: EyeIcon,
  FadersHorizontal: FadersHorizontalIcon,
  FilePdf: FilePdfIcon,
  FileText: FileTextIcon,
  Files: FilesIcon,
  Fire: FireIcon,
  FirstAid: FirstAidIcon,
  FirstAidKit: FirstAidKitIcon,
  FlagCheckered: FlagCheckeredIcon,
  Flame: FlameIcon,
  Gavel: GavelIcon,
  GearSix: GearSixIcon,
  GenderFemale: GenderFemaleIcon,
  GenderMale: GenderMaleIcon,
  Gift: GiftIcon,
  Globe: GlobeIcon,
  GlobeHemisphereWest: GlobeHemisphereWestIcon,
  HandCoins: HandCoinsIcon,
  HandHeart: HandHeartIcon,
  HandsClapping: HandsClappingIcon,
  Headphones: HeadphonesIcon,
  Heart: HeartIcon,
  HeartStraight: HeartStraightIcon,
  HeartHalf: HeartHalfIcon,
  Heartbeat: HeartbeatIcon,
  Hospital: HospitalIcon,
  House: HouseIcon,
  HouseLine: HouseLineIcon,
  IdentificationCard: IdentificationCardIcon,
  ImageBroken: ImageBrokenIcon,
  Images: ImagesIcon,
  Infinity: InfinityIcon,
  Info: InfoIcon,
  Island: IslandIcon,
  Key: KeyIcon,
  Laptop: LaptopIcon,
  Leaf: LeafIcon,
  LetterCircleP: LetterCirclePIcon,
  Lifebuoy: LifebuoyIcon,
  Lightbulb: LightbulbIcon,
  Lightning: LightningIcon,
  ListChecks: ListChecksIcon,
  ListDashes: ListDashesIcon,
  ListMagnifyingGlass: ListMagnifyingGlassIcon,
  Lock: LockIcon,
  LockKey: LockKeyIcon,
  MagicWand: MagicWandIcon,
  MagnifyingGlass: MagnifyingGlassIcon,
  MapPin: MapPinIcon,
  MapPinLine: MapPinLineIcon,
  Medal: MedalIcon,
  MinusCircle: MinusCircleIcon,
  Money: MoneyIcon,
  MoneyWavy: MoneyWavyIcon,
  Newspaper: NewspaperIcon,
  NumberCircleFive: NumberCircleFiveIcon,
  Numpad: NumpadIcon,
  Orange: OrangeIcon,
  Package: PackageIcon,
  PaintBrushHousehold: PaintBrushHouseholdIcon,
  PaperPlaneTilt: PaperPlaneTiltIcon,
  Paperclip: PaperclipIcon,
  Parachute: ParachuteIcon,
  PawPrint: PawPrintIcon,
  Pencil: PencilIcon,
  PencilCircle: PencilCircleIcon,
  PencilSimple: PencilSimpleIcon,
  PersonSimpleBike: PersonSimpleBikeIcon,
  PersonSimpleRun: PersonSimpleRunIcon,
  Phone: PhoneIcon,
  PhoneCall: PhoneCallIcon,
  PicnicTable: PicnicTableIcon,
  PiggyBank: PiggyBankIcon,
  Pill: PillIcon,
  Plant: PlantIcon,
  PlayCircle: PlayCircleIcon,
  Plus: PlusIcon,
  PlusCircle: PlusCircleIcon,
  Prohibit: ProhibitIcon,
  Question: QuestionIcon,
  QuestionMark: QuestionMarkIcon,
  Receipt: ReceiptIcon,
  Scales: ScalesIcon,
  Scroll: ScrollIcon,
  SealCheck: SealCheckIcon,
  SealPercent: SealPercentIcon,
  SealQuestion: SealQuestionIcon,
  Shield: ShieldIcon,
  ShieldCheck: ShieldCheckIcon,
  ShieldCheckered: ShieldCheckeredIcon,
  ShieldWarning: ShieldWarningIcon,
  ShoppingCart: ShoppingCartIcon,
  Signature: SignatureIcon,
  Signpost: SignpostIcon,
  SketchLogo: SketchLogoIcon,
  SlidersHorizontal: SlidersHorizontalIcon,
  Smiley: SmileyIcon,
  SmileyAngry: SmileyAngryIcon,
  SmileyMeh: SmileyMehIcon,
  SmileyNervous: SmileyNervousIcon,
  SmileySad: SmileySadIcon,
  SmileyWink: SmileyWinkIcon,
  Sparkle: SparkleIcon,
  SpinnerGap: SpinnerGapIcon,
  Stamp: StampIcon,
  Star: StarIcon,
  SteeringWheel: SteeringWheelIcon,
  Stethoscope: StethoscopeIcon,
  SuitcaseSimple: SuitcaseSimpleIcon,
  Sun: SunIcon,
  Swap: SwapIcon,
  SwimmingPool: SwimmingPoolIcon,
  Syringe: SyringeIcon,
  TShirt: TShirtIcon,
  Tag: TagIcon,
  Target: TargetIcon,
  ThumbsDown: ThumbsDownIcon,
  ThumbsUp: ThumbsUpIcon,
  Timer: TimerIcon,
  ToggleRight: ToggleRightIcon,
  Tooth: ToothIcon,
  TrainRegional: TrainRegionalIcon,
  Trash: TrashIcon,
  Tree: TreeIcon,
  TrendDown: TrendDownIcon,
  TrendUp: TrendUpIcon,
  UploadSimple: UploadSimpleIcon,
  User: UserIcon,
  UserCircle: UserCircleIcon,
  UserCircleDashed: UserCircleDashedIcon,
  UserFocus: UserFocusIcon,
  UserRectangle: UserRectangleIcon,
  UserSound: UserSoundIcon,
  UserSquare: UserSquareIcon,
  Users: UsersIcon,
  UsersFour: UsersFourIcon,
  UsersThree: UsersThreeIcon,
  VideoCamera: VideoCameraIcon,
  Virus: VirusIcon,
  Wallet: WalletIcon,
  Warning: WarningIcon,
  WarningOctagon: WarningOctagonIcon,
  Wrench: WrenchIcon,
  X: XIcon,
  XCircle: XCircleIcon,
}
